import { Box, VStack, Text, Button, Icon } from "@chakra-ui/react";
import { TimeIcon } from "@chakra-ui/icons";

export default function ComingSoon() {
  return (
    <Box
      w="100%"
      minH="60vh"
      display="flex"
      alignItems="center"
      justifyContent="center"
      bg="gray.50"
      px={4}
      py={10}
    >
      <Box
        maxW="md"
        w="full"
        textAlign="center"
        p={8}
        rounded="xl"
        shadow="md"
        bg="white"
      >
        <VStack spacing={4}>
          <Icon as={TimeIcon} boxSize={8} color="brand.blue" />
          <Text fontSize="2xl" fontWeight="bold" color="gray.800">
            🚀 Coming Soon
          </Text>
          <Text fontSize="md" color="gray.600">
            We’re working hard to bring you something amazing.  
            Stay tuned for updates!
          </Text>
        </VStack>
      </Box>
    </Box>
  );
}
